import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';
import { confirmAlert } from 'react-confirm-alert'; // Import

import {PatientTodaysRecordMomentaryDataListAction,deletePatientTodaysRecordMomentaryDataAction,UpdateCollectedBehaviorData} from '../../actions/BehaviourDataActions';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';
import { change, Field, reduxForm } from 'redux-form';
import { isInteger, renderTextField ,renderAutoCompleteSingleSelect} from '../../../../../../../../components/reduxFields';
import moment from 'moment';

class RecordMomentaryDataViewModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
            creadtedDate: props.creadtedDate
        }
        this.handleDurationChange = this.handleDurationChange.bind(this);
        this.handleIntervalValueChange = this.handleIntervalValueChange.bind(this);
    }

    componentWillMount = () => {
        this.props.PatientTodaysRecordMomentaryDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
    }


    componentDidUpdate(prevProps) {
        if (this.props.patientTodaysRecordMoentaryDataList && this.props.patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData) {
            (this.props.patientTodaysRecordMoentaryDataList && this.props.patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData || []).forEach((obj, index) => {
                this.props.dispatch(change('RecordMomentaryDataViewModalForm', `Behavior1[${index}].value`, obj.value === "Yes" ? 1 : 0));
            });

            (this.props.patientTodaysRecordMoentaryDataList&& this.props.patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData || []).forEach((obj, index) => {
                // console.log('obj........',obj)
                this.props.dispatch(change('RecordMomentaryDataViewModalForm', `Behavior1[${index}].interval`, obj.interval || 0));
            });
        }
    }

    // componentWillReceiveProps(nextProps) {
    //     (nextProps.patientTodaysRecordMoentaryDataList && nextProps.patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData || []).forEach((obj, index) => {
    //         this.props.dispatch(change('RecordMomentaryDataViewModalForm', `Behavior[${index}].interval`, obj.interval || 0));
    //     });
    //     (nextProps.patientTodaysRecordMoentaryDataList && nextProps.patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData || []).forEach((obj, index) => {
    //         this.props.dispatch(change('RecordMomentaryDataViewModalForm', `Behavior[${index}].value`, obj.value || 'No'));
    //     });
    // }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDurationChange = (event, data, action) => {
        this.props.UpdateCollectedBehaviorData(data.id, data.recordMomentaryDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, event.target.value, this.state.patientId, 'INTERVAL', 'MOMENTARY TIME SAMPLE', this.props.uuid, this.state.creadtedDate)
    }

    handleIntervalValueChange = (input, selected,data, action) => {
        input.onChange(selected.value)
        this.props.UpdateCollectedBehaviorData(data.id, data.recordMomentaryDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, selected.value, 0.0, this.state.patientId, 'INTERVALVALUE', 'MOMENTARY TIME SAMPLE', this.props.uuid, this.state.creadtedDate)
    }

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        confirmAlert({
            title: 'Delete Selected Momentary Time Sampling Data',
            message: 'Are you sure you want to delete this Momentary Time Sampling Data?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientTodaysRecordMomentaryDataAction(Obj.recordMomentaryDataDetailId, this.state.patientId, this.props.uuid, this.state.creadtedDate)
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (patientTodaysRecordMoentaryDataList) => {
        patientTodaysRecordMoentaryDataList = patientTodaysRecordMoentaryDataList || [];
        if (!patientTodaysRecordMoentaryDataList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientTodaysRecordMoentaryDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>
                    <td>{showFormatedDateandTime(Obj.sessionDate)}</td>
                    {/* <td>{Obj.elapsedDuration}</td> */}
                    <td>
                        <Field
                            name={`Behavior1[${index}].interval`}
                            type="text"
                            maxLength="2"
                            label="Interval"
                            component={renderTextField}
                            normalize={isInteger}
                            disabled={ this.props.updatePermissionBehavior ? false: true}
                            onBlur={(event) => this.handleDurationChange(event, Obj, 'INTERVAL')}
                        />
                    </td>
                    <td>
                            <Field
                                name={`Behavior1[${index}].value`}
                                type="text"
                                maxLength="3"
                                label="Select Yes or No"
                                component={renderAutoCompleteSingleSelect}
                                options={[{ id: 0, value: "No" }, { id: 1, value: "Yes" }]}
                                disabled={ this.props.updatePermissionBehavior ? false: true}
                                handleNewRequest={(input, selected) => this.handleIntervalValueChange(input, selected, Obj, 'INTERVALVALUE')}
                            />
                    </td>
                    <td>
                        {this.props.deletePermissionBehavior && <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont">
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>}
                    </td>
                </tr>
            )
        })
    }

    renderPatientRecordMomentaryDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientTodaysRecordMoentaryDataList } = this.props;

        let PatientTodaysRecordMoentaryDataList = (patientTodaysRecordMoentaryDataList && patientTodaysRecordMoentaryDataList.data.PatRecordMomentaryData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="40%">Category Name</th>
                                            <th width="30%">Session Date</th>
                                            {/* <th width="15%">Duration</th> */}
                                            <th width="15%">Interval</th>
                                            <th width="15%">Value</th>
                                            <th width="5%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientTodaysRecordMoentaryDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientRecordMomentaryDataList()}
                </Dialog>}
            </div>
        )
    }
}
RecordMomentaryDataViewModal = reduxForm({
    form: 'RecordMomentaryDataViewModalForm',
    enableReinitialize: true,
})(RecordMomentaryDataViewModal);

function mapStateToProps(state)  {
    let userPermissionEdit = [], userPermissionDelete = [];
    let rolename = ""
    if (state.login.userPermission) {
        userPermissionEdit = state.login.userPermission.actionPermissions.filter((obj) => {
            if (obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_BEHAVIOR_DATA") return obj
        });

        userPermissionDelete = state.login.userPermission.actionPermissions.filter((obj)=>{
            if(obj.actionKey==="CLIENT_DATACOLLECTION_DELETE_BEHAVIOR_DATA") return obj
        });

        rolename = state.login.loginUserInfo && state.login.loginUserInfo.users1 && state.login.loginUserInfo.users1.userRoles.roleName
    }


    return {
        rolename: rolename,
        userPermissionEdit: userPermissionEdit,
        userPermissionDelete:userPermissionDelete,
        loading: state.patientRecordMomentaryCustomReducer.loading,
        patientTodaysRecordMoentaryDataList: state.patientRecordMomentaryCustomReducer.todaysMomentaryDataList
    }
}

export default connect(mapStateToProps, { PatientTodaysRecordMomentaryDataListAction, deletePatientTodaysRecordMomentaryDataAction,UpdateCollectedBehaviorData })(RecordMomentaryDataViewModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordMomentary/RecordMoemtaryDataViewModal.js